import { gql } from '@apollo/client';

const SUPPORT_GUIDELINE = gql`
  query supportGuideline {
    supportGuideline {
      id
      faqs {
        id
        question
        answer
      }
      howtoVideos {
        title
        url
        description
      }
      howToVideosBiotres {
        title
        url
        description
      }
      whatIsNew {
        url
        type
      }
      materials {
        onboardingGuide {
          bioflux
          biotres
        }
        featuresManual
        instructionsForUse {
          bioflux
          biotres
        }
        patientQuickGuide {
          bioflux
          biotres
        }
        patientManual {
          bioflux
          biotres
        }
      }
      billingReference
    }
  }
`;

export default SUPPORT_GUIDELINE;
